import { FC } from 'react'
import { Divider } from '@/ui/components/Divider/Divider.styles'
import { IssueStatus as SummaryIssueStatus } from '@/ui/routes/summary/components/IssueStatus'
import { IssuesStatsProps } from './IssuesStats.types'
import { IssuesStatsContainer } from './IssuesStats.styles'

const IssuesStats: FC<IssuesStatsProps> = ({
    leftCount,
    leftDescription,
    rightCount,
    rightDescription,
    className,
}) => {
    return (
        <IssuesStatsContainer className={className}>
            <SummaryIssueStatus
                count={leftCount}
                description={leftDescription}
            />
            <Divider vertical height="48px" margin="0 12px" />
            <SummaryIssueStatus
                count={rightCount}
                description={rightDescription}
            />
        </IssuesStatsContainer>
    )
}

export default IssuesStats
